/**
 * Procesa los datos de eventos y los agrupa por vehículo
 * SOLO considera eventos de apagado/encendido:
 * - Apagados: tipos 3, 5
 * - Encendidos: tipos 4, 6
 * - Otros tipos se ignoran
 */
export function procesarApagadosEncendidos(datos) {
  //console.log('🔄 [PROCESADOR] Iniciando procesamiento de', datos.length, 'eventos');
  
  // 🔍 ANÁLISIS INICIAL: Ver qué tipos de eventos llegan
  const tiposEncontrados = {};
  datos.slice(0, 50).forEach(evento => {  // Solo los primeros 50 para análisis
    const tipo = evento.tipo;
    const nombre = evento.nombreEvento || 'Sin nombre';
    if (!tiposEncontrados[tipo]) {
      tiposEncontrados[tipo] = { count: 0, nombres: new Set() };
    }
    tiposEncontrados[tipo].count++;
    tiposEncontrados[tipo].nombres.add(nombre);
  });
  
  //console.log('📋 [PROCESADOR] Tipos de eventos encontrados en muestra:');
  //Object.entries(tiposEncontrados).forEach(([tipo, data]) => {
  //  console.log(`   Tipo ${tipo}: ${data.count} eventos - Nombres: ${Array.from(data.nombres).join(', ')}`);
  //});
  
  const eventosPorVehiculo = {};
  let contadorEventos = { apagado: 0, encendido: 0, descartados: 0 };
  
  datos.forEach((evento, index) => {
    const uid = evento.vehiculoUid; // ✅ Campo correcto
    
    // ✅ FILTRAR: Solo procesar eventos de apagado/encendido
    let tipoEvento = null;
    let nombreEvento = null;
    
    // 🔍 SOLO TIPOS ESPECÍFICOS: 3,4,5,6 como se especificó
    if ([3, 5].includes(evento.tipo)) { // ← Apagados: tipos 3 y 5
      tipoEvento = 'apagado';
      if (evento.tipo === 3) nombreEvento = `Motor Apagado (${evento.tipo})`;
      else if (evento.tipo === 5) nombreEvento = `Apagado Tipo 5 (${evento.tipo})`;
      contadorEventos.apagado++;
    } else if ([4, 6].includes(evento.tipo)) { // ← Encendidos: tipos 4 y 6
      tipoEvento = 'encendido';
      nombreEvento = evento.tipo === 4 ? `Motor Encendido (${evento.tipo})` : `Encendido Tipo 6 (${evento.tipo})`;
      contadorEventos.encendido++;
    } else {
      // ⛔ DESCARTAR: Eventos que no son de apagado/encendido
      contadorEventos.descartados++;
      //if (index < 10) { // Más logs para entender qué tipos llegan
      //  console.log(`⛔ [PROCESADOR] Descartando evento tipo ${evento.tipo} (${evento.nombreEvento || 'Sin nombre'}) - No es apagado/encendido`);
      //}
      return; // SALIR - No procesar este evento
    }

    // Solo llegamos aquí si es un evento relevante
    if (!eventosPorVehiculo[uid]) {
      eventosPorVehiculo[uid] = {
        uid_vehiculo: uid,
        alias: evento.vehiculos?.alias || 'Sin alias',           // ✅ Campo correcto
        no_economico: evento.vehiculos?.noEconomico || 'Sin #',  // ✅ Campo correcto
        eventos: []
      };
    }

    // Log de eventos relevantes para debug
    //if (contadorEventos.apagado + contadorEventos.encendido <= 20) {
    //  console.log(`✅ [PROCESADOR] Evento relevante ${contadorEventos.apagado + contadorEventos.encendido}: Tipo ${evento.tipo} → ${tipoEvento} (${nombreEvento}) - ${evento.fecha} - Vehículo: ${evento.vehiculos?.alias || 'Sin alias'}`);
    //}
    
    // Log especial para detectar problemas de conteo
    //if ((contadorEventos.apagado + contadorEventos.encendido) % 50 === 0) {
    //  console.log(`📊 [PROCESADOR] Progreso: ${contadorEventos.apagado} apagados, ${contadorEventos.encendido} encendidos, ${contadorEventos.descartados} descartados`);
    //}
    
    eventosPorVehiculo[uid].eventos.push({
      ...evento,
      tipoEvento,
      nombreEvento,
      fecha: new Date(evento.fecha),
      fechaOriginal: evento.fecha,
      // ✅ Campos corregidos para acceso fácil
      alias: evento.vehiculos?.alias || 'Sin alias',
      no_economico: evento.vehiculos?.noEconomico || 'Sin #',
      uid_vehiculo: evento.vehiculoUid
    });
  });

  //console.log('📊 [PROCESADOR] Resumen FINAL de clasificación:', contadorEventos);
  //console.log('📊 [PROCESADOR] Vehículos con eventos relevantes:', Object.keys(eventosPorVehiculo).length);
  
  // Verificación de totales por vehículo
  //let totalApagadosGlobal = 0;
  //let totalEncendidosGlobal = 0;
  
  // Ordenar eventos por fecha dentro de cada vehículo
  Object.values(eventosPorVehiculo).forEach(vehiculo => {
    vehiculo.eventos.sort((a, b) => a.fecha.getTime() - b.fecha.getTime());
    
    //const apagadosVehiculo = vehiculo.eventos.filter(e => e.tipoEvento === 'apagado').length;
    //const encendidosVehiculo = vehiculo.eventos.filter(e => e.tipoEvento === 'encendido').length;
    
    //totalApagadosGlobal += apagadosVehiculo;
    //totalEncendidosGlobal += encendidosVehiculo;
    
    //console.log(`🚗 [PROCESADOR] Vehículo ${vehiculo.alias}: ${vehiculo.eventos.length} eventos relevantes (${apagadosVehiculo} apagados, ${encendidosVehiculo} encendidos)`);
  });
  
  //console.log(`🔢 [PROCESADOR] VERIFICACIÓN TOTALES: ${totalApagadosGlobal} apagados, ${totalEncendidosGlobal} encendidos`);
  
  //if (totalApagadosGlobal !== contadorEventos.apagado || totalEncendidosGlobal !== contadorEventos.encendido) {
  //  console.error(`❌ [PROCESADOR] ERROR EN CONTEO! Contador vs Real: Apagados ${contadorEventos.apagado} vs ${totalApagadosGlobal}, Encendidos ${contadorEventos.encendido} vs ${totalEncendidosGlobal}`);
  //}
  
  return Object.values(eventosPorVehiculo);
}

/**
 * Detecta inconsistencias en los eventos de apagado/encendido
 * Ahora solo recibe eventos relevantes (tipos 3,4,5,6)
 */
export function detectarInconsistencias(datosVehiculos) {
  //console.log('🔍 [DETECTOR] Iniciando detección de inconsistencias en', datosVehiculos.length, 'vehículos');
  
  return datosVehiculos.map((vehiculo, index) => {
    // Ya no necesitamos filtrar porque todos los eventos son relevantes
    const apagados = vehiculo.eventos.filter(e => e.tipoEvento === 'apagado');
    const encendidos = vehiculo.eventos.filter(e => e.tipoEvento === 'encendido');
    
    const totalApagados = apagados.length;
    const totalEncendidos = encendidos.length;
    
    //console.log(`🚗 [DETECTOR] Vehículo ${vehiculo.alias}:`);
    //console.log(`   📊 Total eventos relevantes: ${vehiculo.eventos.length}`);
    //console.log(`   🔴 Apagados: ${totalApagados}`);
    //console.log(`   🟢 Encendidos: ${totalEncendidos}`);
    
    // Mostrar los eventos por tipo para análisis (solo algunos para no saturar)
    //apagados.slice(0, 5).forEach((evento, idx) => {
    //  console.log(`   🔴 Apagado ${idx + 1}: Tipo ${evento.tipo} (${evento.nombreEvento}) - ${evento.fechaOriginal}`);
    //});
    //if (apagados.length > 5) {
    //  console.log(`   🔴 ... y ${apagados.length - 5} apagados más`);
    //}
    
    //encendidos.slice(0, 5).forEach((evento, idx) => {
    //  console.log(`   🟢 Encendido ${idx + 1}: Tipo ${evento.tipo} (${evento.nombreEvento}) - ${evento.fechaOriginal}`);
    //});
    //if (encendidos.length > 5) {
    //  console.log(`   🟢 ... y ${encendidos.length - 5} encendidos más`);
    //}
    
    // Detectar inconsistencias
    let tieneInconsistencia = false;
    let tipoInconsistencia = [];
    
    // Inconsistencia por diferencia de cantidad
    const diferencia = Math.abs(totalApagados - totalEncendidos);
    if (diferencia > 1) {
      tieneInconsistencia = true;
      tipoInconsistencia.push(`Diferencia de ${diferencia} eventos`);
      //console.log(`   ⚠️ INCONSISTENCIA: Diferencia de ${diferencia} eventos`);
    }
    
    // Inconsistencia por secuencia incorrecta
    const secuenciaIncorrecta = validarSecuencia(vehiculo.eventos);
    if (secuenciaIncorrecta.length > 0) {
      tieneInconsistencia = true;
      tipoInconsistencia.push(...secuenciaIncorrecta);
      //console.log(`   ⚠️ INCONSISTENCIA DE SECUENCIA:`, secuenciaIncorrecta);
    }
    
    //console.log(`   ✅ ¿Tiene inconsistencias? ${tieneInconsistencia ? 'SÍ' : 'NO'}`);
    //console.log('   ────────────────────────────────');
    
    return {
      uid_vehiculo: vehiculo.uid_vehiculo,
      alias: vehiculo.alias,
      no_economico: vehiculo.no_economico,
      label: `${vehiculo.no_economico} / ${vehiculo.alias}`,
      totalApagados,
      totalEncendidos,
      tieneInconsistencia,
      tipoInconsistencia,
      eventos: vehiculo.eventos
    };
  }).sort((a, b) => a.alias.localeCompare(b.alias)); // Ordenar alfabéticamente por alias
}

/**
 * Valida la secuencia de eventos apagado/encendido
 * Ahora solo recibe eventos relevantes (tipos 2,4,5,6)
 */
function validarSecuencia(eventos) {
  const inconsistencias = [];
  // Ya no necesitamos filtrar porque todos los eventos son relevantes
  const eventosMotor = eventos; // Todos son de motor ahora
  
  //console.log(`   🔍 [VALIDADOR] Validando secuencia de ${eventosMotor.length} eventos relevantes`);
  
  let ultimoEstado = null; // null, 'encendido', 'apagado'
  
  eventosMotor.forEach((evento, index) => {
    //console.log(`   📋 Evento ${index + 1}: ${evento.tipoEvento} (${evento.nombreEvento}) - ${evento.fechaOriginal}`);
    
    if (evento.tipoEvento === 'apagado') {
      if (ultimoEstado === 'apagado') {
        inconsistencias.push(`Doble apagado detectado`);
        //console.log(`   ❌ DOBLE APAGADO detectado en evento ${index + 1}`);
      }
      ultimoEstado = 'apagado';
    } else if (evento.tipoEvento === 'encendido') {
      if (ultimoEstado === 'encendido') {
        inconsistencias.push(`Doble encendido detectado`);
        //console.log(`   ❌ DOBLE ENCENDIDO detectado en evento ${index + 1}`);
      }
      ultimoEstado = 'encendido';
    }
  });
  
  //console.log(`   🏁 [VALIDADOR] Inconsistencias encontradas: ${inconsistencias.length}`);
  
  return inconsistencias;
}

/**
 * Formatea la fecha para mostrar en la tabla
 */
export function formatearFecha(fecha) {
  if (!fecha) return 'Sin fecha';
  
  const fechaObj = fecha instanceof Date ? fecha : new Date(fecha);
  
  return fechaObj.toLocaleString('es-ES', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  });
}

/**
 * Formatea la distancia en kilómetros
 */
export function formatearDistancia(distancia) {
  if (!distancia) return '0.000 km';
  return `${parseFloat(distancia).toFixed(3)} km`;
}

/**
 * Formatea la velocidad
 */
export function formatearVelocidad(velocidad) {
  if (!velocidad) return '0 km/h';
  return `${parseFloat(velocidad).toFixed(1)} km/h`;
}
